import { fg } from '@atlassian/jira-feature-gating';

const isNinIssueAppConditionalEntrypointSsrEnabledRelayProvider = {
	get(): boolean {
		return fg('nin_issue_app_conditional_entrypoint_ssr');
	},
};

export default isNinIssueAppConditionalEntrypointSsrEnabledRelayProvider;
